module.exports = __webpack_public_path__ + "static/media/Estefania_Monterrosas_Sanchez.f77cfd40.jpg";